import { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { SearchableMenuBody, SearchableMenuMultiSelectList, SearchableMenuProvider, SearchableMenuSearchHeader, useSearchableMenuFuse, } from 'shared/domains/common-ui/SearchableMenu';
import { AddItem } from './AddItem';
import { DistinctValuesForBulkMetadataDocument } from './DistinctValuesForBulkMetadata.gql';
import { MenuFooter } from '../MenuFooter';
import { NoResults } from '../NoResults';
export function SelectWithInput(props) {
    const { property, initialValue = [], onChange, onClear } = props;
    const { label } = property;
    const [selected, setSelected] = useState(initialValue);
    const { data, loading, error } = useQuery(DistinctValuesForBulkMetadataDocument, {
        variables: {
            propertyName: property.name,
        },
    });
    const distinctValues = ((data === null || data === void 0 ? void 0 : data.documentMetadataPairsDistinctValuesForProperty) || []);
    const uniqueValues = [...new Set([...distinctValues, ...selected])].reduce((acc, value) => {
        if (typeof value !== 'string') {
            return acc;
        }
        const trimmedValue = value.trim();
        if (trimmedValue === '') {
            return acc;
        }
        return [...acc, trimmedValue];
    }, []);
    const normalizedValues = uniqueValues.map((party) => ({ id: party, kind: 'item' }));
    const search = useSearchableMenuFuse(normalizedValues, {
        keys: ['id'],
        threshold: 0,
    });
    const handleSave = () => {
        if (selected.length === 0) {
            onClear(property);
        }
        else {
            onChange(property, selected);
        }
    };
    const handleClear = () => {
        onClear(property);
    };
    const handleSelect = (party) => {
        const isSelected = selected.includes(party.id);
        if (isSelected) {
            setSelected(selected.filter((p) => p !== party.id));
        }
        else {
            setSelected([...selected, party.id]);
        }
    };
    if (error) {
        <Menu.ItemNested target={label} loading={loading}>
      <NoResults>
        <Trans comment="Bulk action: Metadata - Distinct values menu - Error">
          An error occurred when fetching the data.
        </Trans>
      </NoResults>
    </Menu.ItemNested>;
    }
    return (<Menu.ItemNested target={label} loading={loading}>
      <SearchableMenuProvider {...search}>
        <SearchableMenuSearchHeader />
        <SearchableMenuBody>
          <SearchableMenuMultiSelectList emptyComponent={<AddItem onAddNewParty={handleSelect}/>} renderListWrapper={false} renderItem={(item) => (<Menu.Item onClick={() => handleSelect(item)} closeOnClick={false}>
                {item.id}
              </Menu.Item>)} selected={selected}/>
        </SearchableMenuBody>

        <MenuFooter onClear={handleClear} onSave={handleSave}/>
      </SearchableMenuProvider>
    </Menu.ItemNested>);
}
